/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_ChooseInputs */

const fr_date_picker_choose = /** @type {(inputs: Date_Picker_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir une date`)
};

const en_date_picker_choose = /** @type {(inputs: Date_Picker_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a date`)
};

/**
* | output |
* | --- |
* | "Choose a date" |
*
* @param {Date_Picker_ChooseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_choose = /** @type {((inputs?: Date_Picker_ChooseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_ChooseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_choose(inputs)
	return fr_date_picker_choose(inputs)
});